import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { token } from '@atlaskit/tokens';

import { useIntl } from '@atlassian/jira-intl';

import authErrorImg from '../../common/assets/authentication-error.svg';
import { ErrorDisplay } from '../../common/ui/error-display';
import { messages } from './messages';

export { messages as authenticationErrorMessagesLegacy };

type DispatchProps = {
	// eslint-disable-next-line jira/react/handler-naming
	login: () => void;
};

export const AuthenticationErrorViewLegacy = (props: DispatchProps) => {
	const intl = useIntl();
	return (
		<ErrorDisplay
			header={intl.formatMessage(messages.authErrorHeader)}
			image={<Image src={authErrorImg} alt="" />}
		>
			<Button
				// @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "primary"; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
				externalId="issue.login"
				appearance="primary"
				onClick={props.login}
				interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view-legacy.button"
			>
				{intl.formatMessage(messages.authButton)}
			</Button>
		</ErrorDisplay>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	width: '160px',
	marginBottom: token('space.200', '16px'),
});
